import React from "react";
import { IMG } from "../../../assets";
import { CONSTANT } from "../../../constant/Constant";
import { motion } from "framer-motion";

export default function Hero({ image }) {
  const array = [
    {
      id: 4,
      icon: IMG.flw,
      title: "Decoration",
      value: "decor",
    },
    {
      id: 5,
      icon: IMG.cam,
      title: "Photography",
      value: "photography",
    },
    {
      id: 3,
      icon: IMG.cat,
      title: "Catering",
      value: "catering",
    },
    {
      id: 6,
      icon: IMG.cak,
      title: "Cakes",
      value: "cake",
    },
    {
      id: 7,
      icon: IMG.music,
      title: "Musical Events",
      value: "music",
    },

    {
      id: 8,
      icon: IMG.bus,
      title: "Transportation",
      value: "transportation",
    },

    {
      id: 9,
      icon: IMG.car,
      title: "Luxury Car ",
      value: "transportation",
    },
    {
      id: 10,
      icon: IMG.dress,
      title: "Rental ",
      value: "transportation",
    },
  ];
  return (
    <div className="h-auto w-full relative flex justify-center items-end">
      <div className="h-full w-full absolute bg-black top-0 z-9 opacity-20" />
      <div className="h-full w-full absolute">
        <img
          className="object-cover h-[100%] w-full"
          src={`${CONSTANT.UI_URL}image/${image}`}
          alt=""
        />
      </div>
      <div className="h-auto w-5/6 max-w-screen-2xl z-9 relative mb-10 mt-[300px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="h-auto w-full text-xl sm:text-3xl 2xl:text-4xl text-white font-satoshi font-thin text-center"
        >
          Welcome to ENCORE Events
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="h-auto w-full text-4xl sm:text-6xl text-white font-mono text-center mt-3"
        >
          &quot;Making Your Special Days Hassle Free&quot;
        </motion.div>

        <div className="h-auto w-full bg-white rounded-[50px] grid grid-cols-1 lg:grid-cols-3 my-10 relative z-10">
          <div className="h-25 flex justify-center items-center w-full">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0 * 0.2 }}
              viewport={{ once: true }}
              className="h-20 lg:border-r-2 w-[95%] border-gray border-r-0 border-b-2 lg:border-b-0 px-8 flex items-center"
            >
              <div className="px-4.5 py-3">
                <h5 className="text-xl font-medium text-bodydark2">
                  Creating Unforgettable Moments —
                </h5>
                <h5 className="text-sm font-medium text-bodydark">
                  One Event at a Time.
                </h5>
              </div>
            </motion.div>
          </div>
          <div className="h-25 flex justify-center items-center ">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1 * 0.2 }}
              viewport={{ once: true }}
              className="h-20 lg:border-r-2 w-[95%] border-gray border-r-0 border-b-2 lg:border-b-0 px-8 flex items-center"
            >
              <div className="px-4.5 py-3">
                <h5 className="text-xl font-medium text-bodydark2">
                  From Dreams to Details —
                </h5>
                <h5 className="text-sm font-medium text-bodydark">
                  We Make Every Event Effortless.
                </h5>
              </div>
            </motion.div>
          </div>
          <div className="h-25 justify-center flex  items-center ">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 2 * 0.2 }}
              viewport={{ once: true }}
              className="h-20  w-[95%] border-gray border-r-0  px-8 flex items-center"
            >
              <div className="px-4.5 py-3">
                <h5 className="text-xl font-medium text-bodydark2">
                  Parties, Concerts, Corporate —
                </h5>
                <h5 className="text-sm font-medium text-bodydark">
                  We Handle It All with Style.
                </h5>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="h-auto w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-8">
          {array.map((data, index) => (
            <motion.button
              className="h-30 flex flex-col justify-center items-center mt-5"
              key={data.id}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-blur  w-[100px] h-[100px] hover:bg-clean hover:opacity-90 rounded-full flex justify-center items-center  outline-offset-2 outline-white ">
                <img className="w-13 h-15" src={data.icon} alt="ring" />
              </div>
              <div>
                <p className="text-xl text-white font-thin font-mono">
                  {data.title}
                </p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </div>
  );
}
